import type { User } from '@/models/User';

export default function identifyUser(
  user: User,
  identifications: ((user: User, language: string) => void)[],
  locale: string,
) {
  identifications.forEach((identify) => identify(user, locale));
}
